import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "../auth/msal";

// MSAL redirect URI handler. handleRedirectPromise() consumes the URL hash
// and resolves either to an auth response or null. We then navigate to the
// originally requested path (carried in `state`).
export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    msalInstance
      .handleRedirectPromise()
      .then((response) => {
        const dest =
          (response?.state as string | undefined) ?? "/";
        // Strip any double-slash or external URL coming from `state`.
        const safe = dest.startsWith("/") ? dest : "/";
        navigate(safe, { replace: true });
      })
      .catch((err: Error) => {
        setError(err.message);
      });
  }, [navigate]);

  return (
    <div className="centered">
      <div className="login-card">
        <div className="login-card__mark" aria-hidden="true" />
        <h1>Accesso in corso…</h1>
        {error ? (
          <p style={{ color: "var(--color-error)" }}>{error}</p>
        ) : (
          <p>Conferma dell'identità con il sistema SSO.</p>
        )}
        <div className="skeleton skeleton--line" />
        <div className="skeleton skeleton--line" style={{ width: "60%" }} />
      </div>
    </div>
  );
}
